import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const FAQPage = lazy(() => import('./index'))

function FAQPageLazy(props) {
    return (
        <Suspense fallback={<Loader/>}>
            <FAQPage {...props} />
        </Suspense>
    );
}

export default FAQPageLazy;
export { FAQPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/faq-page/lazy.js